import useConfig from './config';

export default useConfig;
